import * as Sentry from '@sentry/react';
import { IParlayFilters } from "./types";
import { APIConstants } from "../../utils/api/constants";

export const getParlaysData = (config: IParlayFilters, endDate: string, isDisplayUnlocked: boolean) => {
  const route = 'https://oddsshopper-ui.vercel.app/api/parlays/parlay';

  const params = {
    ...config,
    endDate,
    accesstoken: isDisplayUnlocked ? 'stokasticTools' : '',
    state: config.state?.abbreviation,
  };

  // Convert non-string parameters to strings
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      acc[key] = String(value);
      return acc;
    }, {} as Record<string, string>)
  ).toString();


  return fetch(`${route}?${queryString}`)
    .then(response => response.json())
    .then(data => {
      return {
        status: APIConstants.SUCCEEDED,
        data,
      }
    })
    .catch(error => {
      Sentry.captureException(error);
      console.error('Error:', error);
      return {
        status: APIConstants.FAILED,
        data: error,
      }
    });
};

export const getAdditionalLegs = (config: any, isDisplayUnlocked: boolean) => {
  const route = 'https://oddsshopper-ui.vercel.app/api/parlays/outcomes';

  const params = {
    ...config,
    accesstoken: isDisplayUnlocked ? 'stokasticTools' : '',
  };

  // Convert non-string parameters to strings
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      acc[key] = String(value);
      return acc;
    }, {} as Record<string, string>)
  ).toString();


  return fetch(`${route}?${queryString}`)
    .then(response => response.json())
    .then(data => {
      return {
        status: APIConstants.SUCCEEDED,
        data,
      }
    })
    .catch(error => {
      Sentry.captureException(error);
      console.error('Error:', error);
      return {
        status: APIConstants.FAILED,
        data: error,
      }
    });
};

export const getMatchupsByLeague = (league: string, startDate?: string, endDate?: string) => {
  const route = `https://oddsshopper-ui.vercel.app/api/matchups/${league}`;

  const params = {
    startDate,
    endDate,
    accesstoken: 'stokasticTools',
  };

  // Convert non-string parameters to strings
  const queryString = new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (value) {
        acc[key] = String(value);
      }
      return acc;
    }, {} as Record<string, string>)
  ).toString();


  return fetch(`${route}?${queryString}`)
    .then(response => response.json())
    .then(data => {
      return {
        status: APIConstants.SUCCEEDED,
        data,
      }
    })
    .catch(error => {
      Sentry.captureException(error);
      console.error('Error:', error);
      return {
        status: APIConstants.FAILED,
        data: error,
      }
    });
};